export * from "-!../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dashboard.vue?vue&type=template&id=47121012"


//////////////////
// WEBPACK FOOTER
// ./src/views/Dashboard.vue?vue&type=template&id=47121012
// module id = dPOp
// module chunks = 7